module.exports = __webpack_public_path__ + "img/icloud.db04c9a1.png";